import { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/config';
import { useParams, Link } from 'react-router-dom';


export default function CreditNoteDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  (async () => {
    setLoading(true);
    const token = localStorage.getItem("token"); // ✅ Add this
    const r = await axios.get(`${API_BASE_URL}/api/credit/${id}`, {
      headers: { Authorization: `Bearer ${token}` }, // ✅ Add this
    });
    setData(r.data);
    setLoading(false);
  })();
}, [id]);


  if (loading) return <div className="p-4">Loading...</div>;
  if (!data) return <div className="p-4">Not found</div>;

  const h = data.header;
  const items = data.items || [];

  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Credit Note CN-{h.id}</h1>
        <Link to={`/credit/${h.id}/edit`} className="px-3 py-2 border rounded">Edit</Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <Info title="Customer" value={h.customer_name} />
        <Info title="Date" value={h.credit_note_date ? new Date(h.credit_note_date).toLocaleDateString() : '-'} />
        <Info title="Created By" value={h.created_by_name || '-'} />
        <Info title="Taxable" value={`₹ ${Number(h.total_amount||0).toFixed(2)}`} />
        <Info title="GST" value={`₹ ${Number(h.gst_total||0).toFixed(2)}`} />
        <Info title="Deduction" value={`₹ ${Number(h.deduction||0).toFixed(2)}`} />
        <Info title="Credit Note Amount" value={`₹ ${Number(h.credit_note_amount||0).toFixed(2)}`} />
      </div>

      {h.remarks && (
        <div className="bg-white p-3 rounded-xl shadow">
          <div className="text-xs text-gray-500">Remarks</div>
          <div>{h.remarks}</div>
        </div>
      )}

      <div className="overflow-auto bg-white rounded-xl shadow">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50">
            <tr className="text-left">
              <Th>#</Th>
              <Th>Invoice #</Th>
              <Th>Product</Th>
              <Th>Batch</Th>
              <Th className="text-right">Qty</Th>
              <Th className="text-right">Free</Th>
              <Th className="text-right">Rate</Th>
              <Th className="text-right">GST %</Th>
              <Th className="text-right">GST Amt</Th>
              <Th className="text-right">Line Total</Th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={10} className="p-4">No items</td></tr>
            ) : items.map((it, i) => (
              <tr key={it.id} className="border-t">
                <td className="p-3">{i+1} {it.reason}</td>
                <td className="p-3">{it.invoice_number || '-'}</td>
                <td className="p-3">{it.product_name}</td>
                <td className="p-3 font-mono">{it.batch_no}</td>
                <td className="p-3 text-right">{it.quantity}</td>
                <td className="p-3 text-right">{it.free_qty}</td>
                <td className="p-3 text-right">{Number(it.unit_price||0).toFixed(2)}</td>
                <td className="p-3 text-right">{it.gst_percent ?? '-'}</td>
                <td className="p-3 text-right">{Number(it.gst_amount||0).toFixed(2)}</td>
                <td className="p-3 text-right">{Number(it.total_amount||0).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Th({ children, className='' }) { return <th className={`p-3 text-xs font-semibold text-gray-600 ${className}`}>{children}</th>; }
function Info({ title, value }) {
  return (
    <div className="bg-white rounded-xl shadow p-3">
      <div className="text-xs text-gray-500">{title}</div>
      <div className="font-medium">{value}</div>
    </div>
  );
}